import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  color = 'white', 
  className = '', 
  style = {} 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5', 
    lg: 'h-6 w-6',
    xl: 'h-8 w-8'
  };

  const colorClasses = {
    white: 'text-white',
    blue: 'text-[#44c2fd]',
    gray: 'text-gray-400'
  };

  return (
    <div 
      className={`inline-flex items-center justify-center ${className}`}
      style={style}
    >
      <svg 
        className={`animate-spin ${sizeClasses[size]} ${colorClasses[color]}`}
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        {/* Outer ring with gradient effect */}
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="3"
        />
        
        {/* Spinning arc with gradient */}
        <path 
          className="opacity-90" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
        
        {/* Inner highlight for premium feel */}
        <circle 
          className="opacity-60" 
          cx="12" 
          cy="12" 
          r="6" 
          stroke="currentColor" 
          strokeWidth="1" 
          fill="none"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
